import { render, staticRenderFns } from "./WebServiceConfigurationDetails.vue?vue&type=template&id=fa2e744c&"
import script from "./WebServiceConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./WebServiceConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa2e744c')) {
      api.createRecord('fa2e744c', component.options)
    } else {
      api.reload('fa2e744c', component.options)
    }
    module.hot.accept("./WebServiceConfigurationDetails.vue?vue&type=template&id=fa2e744c&", function () {
      api.rerender('fa2e744c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/WebServiceConfigurationDetails.vue"
export default component.exports